"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var rc_slider_1 = require("rc-slider");
require("rc-slider/assets/index.css");
var React = require("react");
var Gear = require("react-icons/lib/md/settings");
var react_redux_1 = require("react-redux");
var config_1 = require("../config");
var authentication_1 = require("../redux/authentication");
var settings_1 = require("../redux/settings");
var Button_1 = require("./Button");
var Link_1 = require("./Link");
var ModalWindowButton_1 = require("./ModalWindowButton");
var SettingsItem_1 = require("./SettingsItem");
require("./style/Settings.css");
var grey = "#bcc";
var green = "#9db634";
var Settings = /** @class */ (function (_super) {
    __extends(Settings, _super);
    function Settings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Settings.prototype.render = function () {
        var _a = this.props, alarmVolume = _a.alarmVolume, deleteAccount = _a.deleteAccount, notificationOn = _a.notificationOn, setAlarmVolume = _a.setAlarmVolume, signOut = _a.signOut;
        return (React.createElement(ModalWindowButton_1.default, { buttonComponent: function (_a) {
                var opened = _a.opened, openWindow = _a.openWindow;
                return React.createElement("div", { className: "Settings-icon" + (opened ? "-active" : ""), onClick: openWindow },
                    React.createElement(Gear, null));
            } },
            React.createElement("div", { className: "Settings-container" },
                React.createElement(SettingsItem_1.default, { label: "Notification", value: notificationOn
                        ? React.createElement("div", { className: "Settings-notification-enabled" }, "enabled")
                        : React.createElement("div", { className: "Settings-notification-disabled" }, "disabled") }),
                React.createElement(SettingsItem_1.default, { label: "Alarm volume", value: React.createElement("div", { className: "Settings-volume-slider" },
                        React.createElement(rc_slider_1.default, { min: 0, max: 1, defaultValue: 0.5, value: alarmVolume, step: 0.125, marks: { 0: "0", 0.5: "0.5", 1: "1" }, railStyle: { backgroundColor: grey }, trackStyle: { backgroundColor: green }, dotStyle: { background: grey, borderColor: grey }, activeDotStyle: { background: green, borderColor: green }, handleStyle: {
                                background: green,
                                borderColor: green,
                                boxShadow: "none",
                            }, onChange: setAlarmVolume })) }),
                React.createElement("div", { className: "Settings-buttons" },
                    React.createElement(Button_1.default, { onClick: signOut }, "Sign out"),
                    React.createElement(Button_1.default, { className: "Settings-negative-button", onClick: deleteAccount }, "Delete account")),
                React.createElement("div", { className: "Settings-footer" },
                    React.createElement(Link_1.default, { href: config_1.default.feedbackUrl }, "Feedback"),
                    React.createElement(Link_1.default, { href: config_1.default.repositoryUrl }, "GitHub"),
                    React.createElement(Link_1.default, { href: "/terms_of_use.pdf" }, "Terms of Use"),
                    React.createElement(Link_1.default, { href: "/privacy_policy.pdf" }, "Privacy Policy")))));
    };
    return Settings;
}(React.Component));
exports.default = react_redux_1.connect(function (_a) {
    var settings = _a.settings;
    return settings;
}, __assign({}, authentication_1.actionCreators, settings_1.actionCreators))(Settings);



//////////////////
// WEBPACK FOOTER
// ./src/component/Settings.tsx
// module id = 504
// module chunks = 0